import * as Reactstrap from "reactstrap";

/**
 * Workaround para bug da reactstrap 9.2.x.
 * Remover quando a reactstrap corrigir o `Fade.defaultProps` upstream.
 */
const FADE_TIMEOUT = 150;

const { PopperContent, Fade } = Reactstrap as unknown as {
  PopperContent: { defaultProps?: { transition?: Record<string, unknown> } };
  Fade: { propTypes?: Record<string, unknown> };
};

if (PopperContent) {
  PopperContent.defaultProps = {
    ...PopperContent.defaultProps,
    transition: {
      timeout: FADE_TIMEOUT,
      baseClass: "fade",
      baseClassActive: "show",
      appear: true,
      enter: true,
      exit: true,
      ...PopperContent.defaultProps?.transition,
    },
  };
}

if (Fade?.propTypes) {
  Fade.propTypes = { ...Fade.propTypes, timeout: () => null };
}
